import _ from "lodash"

import { HTTP_METHODS } from "./../../../../../constants"
import { makeExternalCall } from "./../../../../../helpers"
import { isRLTLang } from "../../../../../i18n"


const FETCH_OPTIONS_ENDPOINT = "/api/pa/options/list?list_number=14"

const formatOptions = (options) => options.map((option) => (
  { label: isRLTLang() ? option.valueAr : option.valueFr, value: option.rank }))


export const residentialTypesUIHelper = (callback, keyword) => {

  let endpoint = FETCH_OPTIONS_ENDPOINT
  let query = {}
  if (!_.isEmpty(keyword)) {
    query = { q: keyword }
  }

  return new Promise((resolve, reject) =>
    makeExternalCall(HTTP_METHODS.GET, endpoint, {}, {}, query)
      .then(resp => {
        let result = {}
        if (_.isPlainObject(resp.data)) {
          result = [resp.data]
        } else {
          result = resp.data
          console.log(result)
        }
        resolve(callback(formatOptions(result)))
      })
      .catch(err => reject(err.response))
  )
}










export const RESIDENTIAL_TYPES = { 
    1: "RESIDENTIAL_TYPE.HOUSE_RESIDENTIAL_TYPE",
    2: "RESIDENTIAL_TYPE.APARTMENT_RESIDENTIAL_TYPE",
    3: "RESIDENTIAL_TYPE.FARMHOUSE_RESIDENTIAL_TYPE",
  }
  
/* export const residentialTypesUIHelper = (intl) =>
    Object.keys(RESIDENTIAL_TYPES).map((key) => ({
      value: parseInt(key),
      label: intl.formatMessage({ id: RESIDENTIAL_TYPES[key] }),
    })) */
  
    